import { ONBOARDING_TARGETS } from '@/constants/onboarding';

type DesktopStepPosition = 'top' | 'right' | 'bottom' | 'left' | 'center';

type HelperDescriptionKey =
    | 'orderFormDescription'
    | 'balancesDescription'
    | 'tickersDescription'
    | 'chartDescription'
    | 'orderBookDescription'
    | 'blotterDescription'
    | 'marketsDescription'
    | 'accountValueDescription';

type HelperKeywordsKey =
    | 'orderKeywords'
    | 'balancesKeywords'
    | 'tickersKeywords'
    | 'chartKeywords'
    | 'orderBookKeywords'
    | 'blotterKeywords'
    | 'marketsKeywords'
    | 'accountValueKeywords';

export interface OnboardingModuleStepDefinition {
    id: string;
    key: string;
    copyKey: string;
    targetSelector: string;
    desktopPosition: DesktopStepPosition;
    helperDescriptionKey: HelperDescriptionKey;
    helperKeywordsKey: HelperKeywordsKey;
    horizontalPadding?: number;
}

const getTraderSteps = (): OnboardingModuleStepDefinition[] => [
    {
        id: 'markets',
        key: 'markets',
        copyKey: 'markets',
        targetSelector: ONBOARDING_TARGETS.markets,
        desktopPosition: 'left',
        helperDescriptionKey: 'marketsDescription',
        helperKeywordsKey: 'marketsKeywords',
        horizontalPadding: 2
    },
    {
        id: 'tickers',
        key: 'tickers',
        copyKey: 'tickers',
        targetSelector: ONBOARDING_TARGETS.tickers,
        desktopPosition: 'bottom',
        helperDescriptionKey: 'tickersDescription',
        helperKeywordsKey: 'tickersKeywords',
        horizontalPadding: 2
    },
    {
        id: 'order-book',
        key: 'order-book',
        copyKey: 'orderBook',
        targetSelector: ONBOARDING_TARGETS.orderBook,
        desktopPosition: 'right',
        helperDescriptionKey: 'orderBookDescription',
        helperKeywordsKey: 'orderBookKeywords',
        horizontalPadding: 2
    },
    {
        id: 'chart',
        key: 'chart',
        copyKey: 'chart',
        targetSelector: ONBOARDING_TARGETS.chart,
        desktopPosition: 'right',
        helperDescriptionKey: 'chartDescription',
        helperKeywordsKey: 'chartKeywords',
        horizontalPadding: 2
    },
    {
        id: 'account-value',
        key: 'account-value',
        copyKey: 'accountValue',
        targetSelector: ONBOARDING_TARGETS.accountValue,
        desktopPosition: 'left',
        helperDescriptionKey: 'accountValueDescription',
        helperKeywordsKey: 'accountValueKeywords',
        horizontalPadding: 2
    },
    {
        id: 'blotter',
        key: 'blotter',
        copyKey: 'blotter',
        targetSelector: ONBOARDING_TARGETS.blotter,
        desktopPosition: 'right',
        helperDescriptionKey: 'blotterDescription',
        helperKeywordsKey: 'blotterKeywords',
        horizontalPadding: 2
    }
];

const getSpotSteps = (): OnboardingModuleStepDefinition[] => {
    const spotSteps = getTraderSteps();

    const tickerIndex = spotSteps.findIndex((step) => step.key === 'tickers');
    const accountValueIndex = spotSteps.findIndex((step) => step.key === 'account-value');

    // Replace the ticker and account value steps with the spot-specific ones if needed

    spotSteps[tickerIndex] = {
        id: 'order',
        key: 'order',
        copyKey: 'orderForm',
        targetSelector: ONBOARDING_TARGETS.orderForm,
        desktopPosition: 'bottom',
        helperDescriptionKey: 'orderFormDescription',
        helperKeywordsKey: 'orderKeywords',
        horizontalPadding: 2
    };

    spotSteps[accountValueIndex] = {
        id: 'balances',
        key: 'balances',
        copyKey: 'balances',
        targetSelector: ONBOARDING_TARGETS.balances,
        desktopPosition: 'left',
        helperDescriptionKey: 'balancesDescription',
        helperKeywordsKey: 'balancesKeywords',
        horizontalPadding: 2
    };

    return spotSteps;
};

export const getOnboardingModuleSteps = (isTraderRoute: boolean): OnboardingModuleStepDefinition[] =>
    isTraderRoute ? getTraderSteps() : getSpotSteps();
